// Convex API typed-binding shim.
//
// In a normal Convex project this file is auto-generated as `_generated/api.ts`
// inside the convex/ folder of the SAME project. But the consent route lives
// in its own folder (cloudflare_consent/), separate from ccl_mcp_convex/. We
// could symlink, but the cleaner approach is to import via the Convex
// `anyApi` helper which works without the typed bindings.
//
// To get full type-safety, copy the auto-generated _generated/api.d.ts from
// ccl_mcp_convex/convex/_generated/ into cloudflare_consent/src/_generated/
// after `npx convex dev` runs, and re-export from here. For v1, anyApi is fine.

import { anyApi } from "convex/server";

export const api = anyApi as unknown as {
  oauth: {
    createAuthCode: any;
    getMyEntitlements: any;
    listMyClients: any;
    revokeMyClient: any;
  };
};
